<template>
  <!-- The brand as it now appears in Spyder: tracked, live, history building.
  Context: brandName, brandAvatar -->
  <div>
    <!-- Window header -->
    <div class="flex items-center gap-2 px-3.5 py-2 border-b border-border-normal">
      <SpyderIcon
        :width="14"
        :height="14"
        class="text-primary-red-100"
      />
      <BaseText
        type="label"
        size="xs"
        class="text-text-muted"
      >
        Spyder · Tracked brands
      </BaseText>
      <div class="ml-auto flex items-center gap-1">
        <span class="scene-dot" />
        <span class="scene-dot" />
        <span class="scene-dot" />
      </div>
    </div>
    <!-- Brand row -->
    <div class="flex items-center gap-3 px-3.5 pt-3 pb-3">
      <div class="flex-shrink-0 w-10 h-10 rounded-lg overflow-hidden flex items-center justify-center bg-primary-red-100">
        <img
          v-if="avatar"
          :src="avatar"
          alt=""
          class="w-full h-full object-cover"
        >
        <BaseText
          v-else
          type="label"
          size="sm"
          class="text-white"
        >
          {{ initials }}
        </BaseText>
      </div>
      <div class="min-w-0 flex-grow">
        <BaseText
          type="label"
          size="sm"
          class="text-text-loud truncate"
        >
          {{ brandName }}
        </BaseText>
        <div class="flex items-center gap-1.5 mt-0.5">
          <span class="scene-live-dot" />
          <BaseText
            type="body"
            size="xs"
            class="text-text-subdued"
          >
            Tracking live · new ads flagged as they launch
          </BaseText>
        </div>
      </div>
      <!-- Mini activity bars: history building -->
      <div class="flex items-end gap-0.5 h-7 flex-shrink-0">
        <span
          v-for="(height, index) in bars"
          :key="`bar-${index}`"
          class="scene-bar rounded-sm"
          :style="{ height: `${height}%`, animationDelay: `${index * 40}ms` }"
        />
      </div>
    </div>
    <!-- Stat strip -->
    <div class="grid grid-cols-3 border-t border-border-normal">
      <div
        v-for="(stat, index) in stats"
        :key="stat.label"
        class="px-3.5 py-2"
        :class="index > 0 ? 'border-l border-border-normal' : ''"
      >
        <BaseText
          type="label"
          size="xs"
          class="text-text-loud"
        >
          {{ stat.value }}
        </BaseText>
        <BaseText
          type="body"
          size="xs"
          class="text-text-subdued"
        >
          {{ stat.label }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import SpyderIcon from '../../globals/Icons/SidebarIcons/SpyderIcon.vue'

export default {
  name: 'BrandTrackedScene',
  components: {
    SpyderIcon
  },
  props: {
    context: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      bars: [30, 45, 40, 62, 55, 78, 70, 100],
      stats: [
        { value: 'On', label: 'New ad alerts' },
        { value: 'Daily', label: 'Library refresh' },
        { value: 'Building', label: 'Ad history' }
      ]
    }
  },
  computed: {
    brandName () {
      return this.context.brandName || 'Your brand'
    },
    avatar () {
      return this.context.brandAvatar || null
    },
    initials () {
      const parts = this.brandName.split(' ').filter(Boolean)
      return parts.slice(0, 2).map((part) => part[0].toUpperCase()).join('') || 'B'
    }
  }
}
</script>

<style scoped>
.scene-dot {
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: theme('colors.neutral.100');
}
.scene-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background-color: theme('colors.primary.red-100');
  box-shadow: 0 0 0 0 rgba(237, 97, 90, 0.4);
  animation: scene-live-pulse 1.8s ease-out infinite;
}
.scene-bar {
  width: 5px;
  background-color: rgba(237, 97, 90, 0.35);
  transform-origin: bottom;
  animation: scene-bar-in 500ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.scene-bar:last-child {
  background-color: theme('colors.primary.red-100');
}
@keyframes scene-live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(237, 97, 90, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(237, 97, 90, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(237, 97, 90, 0);
  }
}
@keyframes scene-bar-in {
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .scene-live-dot,
  .scene-bar {
    animation: none;
  }
}
</style>
